module.exports = __webpack_public_path__ + "static/img/13.6ddfe31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/horse/13.png
// module id = G7s1
// module chunks = 1